export const environment = {
  envName: 'heprod',
  production: true,
  mockServices: false,
  apiBaseUrl: 'https://oha.he.aok.de:8443/api/',
  customizingAok: {
    Name: 'AOK Hessen',
    Href: 'https://www.aok.de/pk/hessen/',
    ImpressumHref: 'https://www.aok.de/pk/hessen/inhalt/impressum-8/',
    DatenschutzHref: 'https://www.aok.de/pk/rechtliches/datenschutzerklaerung/',
    DatenschutzRechteHref: 'https://www.aok.de/pk/hessen/inhalt/informationen-zur-datenverarbeitung-4/',
    OhaServiceMail: 'oha@he.aok.de',
    Logo: 'logo_aok.jpg'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts